import React, { useState } from "react";
import styles from "../SmarterReception/SmarterReception.module.css";
import AnimatedBtn from "../../AnimatedBtn/AnimatedBtn";
import MobSmarter from "./MobSmarter";

const SmarterReception = ({ smarterReceptiondata }) => {
  console.log(smarterReceptiondata, "smarterReceptiondata");
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    setIsPlaying(true);
  };

  const topLeft = smarterReceptiondata?.cards?.find(
    (c) => c?.position === "topLeft"
  );
  const bottomLeft = smarterReceptiondata?.cards?.find(
    (c) => c?.position === "bottomLeft"
  );
  const topRight = smarterReceptiondata?.cards?.find(
    (c) => c?.position === "topRight"
  );
  const bottomRight = smarterReceptiondata?.cards?.find(
    (c) => c?.position === "bottomRight"
  );
  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        <div className={styles.FirstCard}>
          <div>
            <div className={styles.Part1Img}>
              <img src="/Svg/part-1-top-shape.svg" alt="part-1-top-shape" />{" "}
            </div>
            <div className={styles.Part1}>
              <h3>{topLeft?.heading || ""}</h3>
              {topLeft?.text ? <p>{topLeft.text}</p> : null}
              <div className={styles.watch2}>
                <img
                  src={topLeft?.icon?.src || "/Svg/watch2-icon.svg"}
                  alt={topLeft?.heading || "card icon"}
                />
              </div>
            </div>
          </div>

          <div className={styles.Part2}>
            <div className={styles.callIcon}>
              <img
                src={bottomLeft?.icon?.src || "/Svg/call-icon2.svg"}
                alt={bottomLeft?.heading || "card icon"}
              />
            </div>
            <h3>{bottomLeft?.heading || ""}</h3>
          </div>
        </div>
        <div className={styles.SecondtCard}>
          <div
            className={styles.AnimatedBtnDiv}
            onClick={() =>
              window.open(
                "https://app.rxpt.ai/",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            {smarterReceptiondata?.cta?.href ? (
              <a href={smarterReceptiondata.cta.href}>
                <AnimatedBtn
                  text={
                    smarterReceptiondata?.cta?.label || "Get Started for FREE"
                  }
                />
              </a>
            ) : (
              <AnimatedBtn
                text={
                  smarterReceptiondata?.cta?.label || "Get Started for FREE"
                }
              />
            )}
          </div>
          <div className={styles.videoContainer}>
            {!isPlaying ? (
              <div className={styles.thumbnailWrapper} onClick={handlePlay}>
                <img
                  src={
                    smarterReceptiondata?.video?.thumbnail?.src ||
                    "/Images/features-thumbnail.png"
                  }
                  alt="features-thumbnail"
                  className={styles.thumbnail}
                />
                <div className={styles.playButton}>
                  <img src="/Svg/play-button.svg" alt="play-button" />
                </div>
              </div>
            ) : (
              <video
                className={styles.video}
                controls
                autoPlay
                poster={smarterReceptiondata?.video?.thumbnail?.src}
              >
                <source
                  src={
                    smarterReceptiondata?.video?.src ||
                    "/Video/smart-stats-demo.mp4"
                  }
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        </div>
        <div className={styles.ThirdtCard}>
          <div>
            <div className={styles.Part3Img}>
              <img src="/Svg/part-3-top-shape.svg" alt="part-1-top-shape" />{" "}
            </div>
            <div className={styles.Part3}>
              <h3>{topRight?.heading}</h3>
              <p>{topRight?.text}</p>
              <div className={styles.watch}>
                <img
                  src={topRight?.icon?.src || "/Svg//website-widget.svg"}
                  alt={topRight?.heading || "card icon"}
                />
              </div>
            </div>
          </div>

          <div className={styles.Part4}>
            <div className={styles.analyticsIcon}>
              <img
                src={bottomRight?.icon?.src || "/Svg/analytics-report.svg"}
                alt={bottomRight?.heading || "card icon"}
              />
            </div>
            <h3>{bottomRight?.heading}</h3>
          </div>
        </div>
      </div>
      <div className={styles.MobSmarterDiv}>
        <MobSmarter />
      </div>
    </div>
  );
};

export default SmarterReception;
